import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-icon_status_pending",
  "use": "svg-icon-icon_status_pending-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"svg-icon-icon_status_pending\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 .062h12v12H0z\" /><path d=\"M0 1.005v9.99a1 1 0 0 0 1.486.874l8.99-4.994a1 1 0 0 0 0-1.749L1.487.131A1 1 0 0 0 0 1.005z\" fill=\"orange\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol